module.exports = __webpack_public_path__ + "static/media/sozo.b99dd222.jpg";